export const WS_CONNECT = 'WS_CONNECT';
export const WS_DISCONNECT = 'WS_DISCONNECT';
export const WS_THREAD_VIEWED = 'WS_THREAD_VIEWED';
export const WS_SYNC_MESSAGE = 'WS_SYNC_MESSAGE';
export const WS_THREAD_SYNC_MESSAGE = 'WS_THREAD_SYNC_MESSAGE';
